import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';
import { WorkItemDataVersionPreference } from 'runtime/data/workitemdataversionpreference';

export class AmbiguousDataVersionDialog implements IDialog {
    options: IDialogOptions;
    private dialogContent: JQuery;

    constructor(resources: IResourceProvider, action: (x: WorkItemDataVersionPreference) => void, closeAction?: () => void) {
        this.options = {
            title: resources.getCoreString('LblWorkItemDataVersion'),
            width: 400,
            height: 200,
            dialogClass: 'wf-worktray-item-dialog',
            buttons: [
                { text: resources.getCoreString('XamlSaved'), click: () => this.actAndClose(() => action(WorkItemDataVersionPreference.PreferSaved)) },
                { text: resources.getCoreString('XamlOriginal'), click: () => this.actAndClose(() => action(WorkItemDataVersionPreference.PreferSubmitted)) },
                { text: resources.getCoreString('XamlClose'), click: () => this.actAndClose(closeAction ? closeAction : () => {}) }
            ],
            create: () => {
                $('.ui-dialog-buttonset > button', this.dialogContent.parent()).css('min-width', '80px');
            }
        }
        this.dialogContent = $('<div />').text(resources.getCoreString('XamlAmbiguousDataVersionDialogMessage'));
    }

    content(): JQuery {
        return this.dialogContent;
    }

    private close(): void {
        this.dialogContent.dialog('close');
    }

    private actAndClose(action: () => void) {
        action();
        this.close();
    }
}